import styled, { css } from 'styled-components';

import { mediaConfined, mediaNavExtended } from '@xing-com/layout-tokens';
import { spaceXL } from '@xing-com/tokens';

import {
  MIN_WIDTH,
  PADDING_MEDIUM_LARGE,
  PADDING_XSMALL_SMALL,
  PADDING_WIDE,
} from './constants';

const sectionBlockPadding = css`
  padding-block: ${spaceXL};
`;

const sectionInlinePadding = css`
  padding-inline: ${PADDING_XSMALL_SMALL};

  @media ${mediaConfined} {
    padding-inline: ${PADDING_MEDIUM_LARGE};
  }

  @media ${mediaNavExtended} {
    padding-inline: ${PADDING_WIDE};
  }
`;

/** A simple section wrapper with responsive paddings */
export const Section = styled.section<{
  /** Removes the top/bottom padding (or others depending on element orientation) */
  noBlockPadding?: boolean;
  /** Removes the left/right padding (or others depending on element orientation) */
  noPagePadding?: boolean;
}>`
  min-width: ${MIN_WIDTH}px;

  ${({ noBlockPadding }) => (noBlockPadding ? null : sectionBlockPadding)};
  ${({ noPagePadding }) => (noPagePadding ? null : sectionInlinePadding)}
`;
